import { Component, Input, Optional } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Storage } from '@ionic/storage';

/**
 * Generated class for the GdAvatarPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'gd-avatar',
  templateUrl: 'gd-avatar.html',
})
export class GdAvatarPage {

  SFGoAuth: any = [];
  initial: any;

  @Input() achievementBadge: any = null;
  @Input() userId: any;
  @Input() photo: any;
  @Input() fullname: any;
  @Input() favorite: any = false;
  @Input() type: any = 'PROFILE';
  @Input() data: any;
  @Input() onPresent: boolean = false;

  constructor(
    @Optional()
    public navCtrl: NavController,
    @Optional()
    public navParams: NavParams,
    public storage: Storage
  ) {
  }

  ngOnChanges() {
    this.photo = this.photo;
  }

  ngAfterViewChecked() {
    if (this.fullname) {
      let tempName = this.fullname.split(" ");
      if (tempName.length > 1) {
        this.initial = tempName[0].substring(0, 1) + tempName[1].substring(0, 1).toUpperCase();
      } else {
        this.initial = this.fullname.substring(0, 1);
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/gd-avatar/gd-avatar.ts